module.exports = __webpack_public_path__ + "static/media/Carp.metal.b26db63d.png";